export default __webpack_public_path__ + "static/clusters-e9669d7224447c717f00dcbd557e0c47.webp";